import classNames from 'classnames';
// import {SvgPlainDown} from '@baidu/luffy-icon';
// import {Button as LuffyButton} from '@baidu/luffy-comp-button';
import {
    DropMenu as LuffyDropMenu,
    DropMenuProps as LuffyDropMenuProps,
} from '@baidu/luffy-comp-drop-menu';
import {Props} from '@/interface';

export type {DropMenuValue, DropMenuOptionObject} from '@baidu/luffy-comp-drop-menu';
import styles from './index.module.scss';

export enum DropMenuType {
    Normal = 'normal',
    Plain = 'plain',
}

export enum DropMenuTrigger {
    Click = 'click',
    Hover = 'hover',
}

export enum DropMenuSize {
    XS = 'xs',
    SM = 'sm',
    MD = 'md',
    LG = 'lg',
}

interface DropMenuProps extends LuffyDropMenuProps, Props{
    type?: DropMenuType;
    // trigger?: DropMenuTrigger;
}

export default function DropMenu(props: DropMenuProps) {


    const {
        children,
        type = DropMenuType.Normal,
        className,
        ...dropMenuProps
    } = props;

    const dropMenuClass = classNames(
        type === DropMenuType.Plain && styles.plain,
        className
    );

    return (
        <LuffyDropMenu
            className={dropMenuClass}
            {...dropMenuProps}
        >
            {children}
        </LuffyDropMenu>
    );
}
